module.exports = __webpack_public_path__ + "static/media/crampons.ae433a9a.webp";